<template>
  <subPageBanner pageTitle="txt_bulunamadi" />

  <div class="container-fuild page-404-following-area">
    <div class="container">
      <div class="row">
        <div class="col-12 page-404-following-main">
          <h4>{{this.$store.getters.getWordLocale("txt_sayfalara_goz_atabilirsiniz")}}</h4>

          <div class="contact-detail-info-c row m-0 p-0">
            <div class="col-12 col-sm-6 col-md-3 contact-detail-info-item">
              <i class="material-icons-outlined">home</i>
              <b>{{this.$store.getters.getWordLocale("txt_anasayfa")}}</b> <a :href="'/' + this.$store.state.langCodeX">{{this.$store.getters.getWordLocale("txt_git")}}</a>
            </div>
            <div class="col-12 col-sm-6 col-md-3 contact-detail-info-item">
              <i class="material-icons-outlined">business</i>
              <b>{{this.$store.getters.getWordLocale("txt_hakkimizda")}}</b><a :href="'/' + this.$store.state.langCodeX + '/about'">{{this.$store.getters.getWordLocale("txt_oku")}}</a>
            </div>
            <div class="col-12 col-sm-6 col-md-3 contact-detail-info-item">
              <i class="material-icons-outlined">shopping_cart</i>
              <b>{{this.$store.getters.getWordLocale("txt_urunlerimiz")}}</b><a :href="'/' + this.$store.state.langCodeX + '/products'">{{this.$store.getters.getWordLocale("txt_goz_at")}}</a>
            </div>
            <div class="col-12 col-sm-6 col-md-3 contact-detail-info-item">
              <i class="material-icons-outlined">phone</i>
              <b>{{this.$store.getters.getWordLocale("txt_iletisim")}}</b><a :href="'/' + this.$store.state.langCodeX + '/contact'">{{this.$store.getters.getWordLocale("txt_ara")}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subPageBanner from "./components/SubPageBanner.vue";

export default {
  components: {
    subPageBanner,
  },
};
</script>

<style scoped>
.contact-detail-info-c {
  padding: 15px 150px;
}
.page-404-following-area {
  margin-top: 50px;
  margin-bottom: 25;
}
.page-404-following-main h4 {
  padding: 0px 0px 50px 0px;
  text-align: center;
  font-size: 22px;
}
hr {
  margin: 50px 0;
  color: inherit;
  background-color: var(--m3--sys--light--outline);
  border: 0;
  opacity: 1;
}
.page-404-following-main {
  padding: 50px 100px;
  background: #ffffff;
}

.product-list .page-404-following-all-product {
  text-align: center;
  margin-top: 62px;
}
.product-list .page-404-following-all-product > a {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  color: var(--m3--ref--tertiary--tertiary40);
  padding: 8px 12px;
  border: 1px solid var(--m3--ref--tertiary--tertiary40);
  border-radius: 5px;
}

.subpage-title h1 {
  padding: 28px;
}
.contact-detail-info-item {
  text-align: center;
}
.contact-detail-info-item > i {
  color: var(--m3--sys--light--primary);
  font-size: 48px;
  width: 100px;
  height: 100px;
  background-color: #ebf1ff;
  line-height: 2;
  border-radius: 50%;
}
.contact-detail-info-item > b {
  color: var(--m3--sys--light--on-surface);
  font-family: DM Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  text-align: center;
  font-feature-settings: "liga" off;
  margin-bottom: 17px;
  display: block;
  margin-top: 17px;
}
.contact-detail-info-item > span {
  color: var(--m3--sys--light--on-surface);
  font-family: DM Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.5px;
}

.contact-form {    
    margin-top: 0px !important;
}
</style>
